import React from "react";
import {Centre} from "../Centre";

export const EmptyEmailSearch = () => {
    return <Centre>No emails found - try adjusting the search terms</Centre>
};
